import { localeNamespaces, type LocaleNamespace } from './loadLocale';

const LEGAL_PREFIXES = [
  '/cookies',
  '/admin/legal',
];

const EXTRA_NAMESPACE_BY_PATH: Record<string, LocaleNamespace | readonly LocaleNamespace[]> = {
  '/software-pre-elektrikarov': 'tradeLandings',
  '/software-pre-murarov': 'tradeLandings',
  '/software-til-murer': 'tradeLandings',
  '/software-til-tagdaekker': 'tradeLandings',
  '/software-pre-pokryvacov': 'tradeLandings',
  '/software-pro-pokryvace': 'tradeLandings',
  '/software-for-roofers': 'tradeLandings',
  '/software-til-kloakmester': 'tradeLandings',
  '/software-pro-elektrikare': 'tradeLandings',
  '/software-til-elektriker': 'tradeLandings',
  '/software-for-electricians': 'tradeLandings',
  '/software-pre-instalaterov': 'tradeLandings',
  '/software-pro-instalatery': 'tradeLandings',
  '/software-til-vvs': 'tradeLandings',
  '/software-for-plumbers': 'tradeLandings',
  '/software-pre-maliarov': 'tradeLandings',
  '/software-pro-malire': 'tradeLandings',
  '/software-til-maler': 'tradeLandings',
  '/software-for-painters': 'tradeLandings',
  '/software-pre-stolarov-a-tesarov': 'tradeLandings',
  '/software-pro-truhlare-a-tesare': 'tradeLandings',
  '/software-til-toemrer': 'tradeLandings',
  '/software-for-carpenters': 'tradeLandings',
  '/software-pre-generalneho-dodavatela': 'tradeLandings',
  '/software-pro-generalniho-dodavatele': 'tradeLandings',
  '/software-til-hovedentreprenor': 'tradeLandings',
  '/software-for-general-contractors': 'tradeLandings',
  '/servisny-system': 'tradeLandings',
  '/servisni-system': 'tradeLandings',
  '/servicesystem': 'tradeLandings',
  '/field-service-software': 'tradeLandings',
  '/zakaznicky-portal': 'customerPortal',
  '/kundeportal': 'customerPortal',
  '/customer-portal': 'customerPortal',
  '/bozp-software': 'bozpLanding',
  '/arbejdsmiljo': 'bozpLanding',
  '/health-and-safety-software': 'bozpLanding',
  '/pre-uctovnikov': 'tradeLandings',
  // Journey page once the language has trades/accountant.json, see AccountantLanding.
  '/pro-ucetni': ['tradeLandings', 'forAccountants'],
  '/til-revisorer': ['tradeLandings', 'forAccountants'],
  '/for-accountants': ['tradeLandings', 'forAccountants'],
  '/digital-bogfoering': 'digitalBookkeeping',
  // Long SEO guides, see utils/longForm.ts.
  // Every language of these two pages loads the namespace (empty where a
  // language has no guide yet), so the page never waits for it.
  '/webstranka-pre-remeselnika': 'longForm',
  '/webova-stranka-pro-remeslnika': 'longForm',
  '/hjemmeside-til-haandvaerker': 'longForm',
  '/website-for-tradespeople': 'longForm',
  '/informacny-system-pre-firmu': 'longForm',
  '/cela-firma-v-jednom': 'longForm',
  '/hele-firmaet-i-et-system': 'longForm',
  '/the-whole-firm-in-one-system': 'longForm',
  '/website-fuer-handwerker': 'longForm',
  '/der-ganze-betrieb-in-einem-system': 'longForm',
  // AI in Bidmio: one file per language (locales/<lang>/aiPage.json).
  '/ai-v-bidmio': 'aiPage',
  '/ai-v-bidmiu': 'aiPage',
  '/ai-i-bidmio': 'aiPage',
  '/ai-in-bidmio': 'aiPage',
  '/ki-in-bidmio': 'aiPage',
  // German (www.bidmio.de)
  '/software-fuer-elektriker': 'tradeLandings',
  '/software-fuer-dachdecker': 'tradeLandings',
  '/software-fuer-shk': 'tradeLandings',
  '/software-fuer-maler': 'tradeLandings',
  '/software-fuer-tischler-und-zimmerer': 'tradeLandings',
  '/software-fuer-bauunternehmen': 'tradeLandings',
  '/kundendienst-software': 'tradeLandings',
  '/kundenportal': 'customerPortal',
  '/arbeitsschutz-software': 'bozpLanding',
  '/fuer-steuerberater': ['tradeLandings', 'forAccountants'],
};

export function namespacesForPath(pathname: string): LocaleNamespace[] {
  const namespaces = new Set<LocaleNamespace>(['common']);
  const path = pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname;

  if (path === '/blog' || path.startsWith('/blog/')) {
    namespaces.add('articles');
  }

  if (LEGAL_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    namespaces.add('legal');
  }

  const extra = EXTRA_NAMESPACE_BY_PATH[path];
  for (const namespace of extra === undefined ? [] : [extra].flat()) namespaces.add(namespace);

  return localeNamespaces.filter((namespace) => namespaces.has(namespace));
}
